<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-mode", "data-fullscreen", "data-touched", "data-playing", "data-paused", "data-waiting", "data-loaded", "data-muted"];
import { ref, provide } from "vue";
import defu from "defu";
import { usePlayerVideoApi } from "../composables/private/usePlayerVideoApi";
import { usePlayerMediaApi } from "../composables/private/usePlayerMediaApi";
import { usePlayerRuntime } from "../composables/private/usePlayerRuntime";
import { MagicPlayerInstanceId, MagicPlayerOptionsKey } from "../symbols";
import { defaultOptions } from "../utils/defaultOptions";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicPlayerProvider",
  props: {
    id: { type: null, required: true },
    options: { type: Object, required: false }
  },
  setup(__props) {
    const mappedOptions = defu(__props.options, defaultOptions);
    const playerRef = ref(void 0);
    const { playing, waiting, muted } = usePlayerMediaApi({
      id: __props.id
    });
    const { loaded } = usePlayerRuntime({
      id: __props.id,
      src: mappedOptions.src,
      srcType: mappedOptions.srcType
    });
    const { onMouseenter, onMouseleave, isFullscreen, touched } = usePlayerVideoApi(
      {
        id: __props.id,
        playerRef
      }
    );
    provide(MagicPlayerInstanceId, __props.id);
    provide(MagicPlayerOptionsKey, mappedOptions);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "playerRef",
        ref: playerRef,
        class: "magic-player-provider",
        "data-mode": _unref(mappedOptions).mode,
        "data-fullscreen": _unref(isFullscreen),
        "data-touched": _unref(touched),
        "data-playing": _unref(playing),
        "data-paused": !_unref(playing),
        "data-waiting": _unref(waiting),
        "data-loaded": _unref(loaded),
        "data-muted": _unref(muted),
        onMouseenter: _cache[0] || (_cache[0] = //@ts-ignore
        (...args) => _unref(onMouseenter) && _unref(onMouseenter)(...args)),
        onMouseleave: _cache[1] || (_cache[1] = //@ts-ignore
        (...args) => _unref(onMouseleave) && _unref(onMouseleave)(...args))
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 40, _hoisted_1);
    };
  }
});
</script>

<style>
.magic-player-provider {
  position: relative;
  width: 100%;
}

.magic-player-provider[data-mode='video'] {
  overflow: hidden;
  height: var(--magic-player-provider-height, auto);
  aspect-ratio: var(--magic-player-provider-aspect-ratio, 16 / 9);
  background: var(--magic-player-provider-background, #000);
}

.magic-player-provider[data-loaded='true'][data-mode='video'] {
  --magic-player-provider-background: transparent;
}

.magic-player-provider[data-mode='audio'] {
  position: relative;
  width: 100%;
}
</style>
